import { Injectable } from '@angular/core';
import {Cart} from "../classes/cart";
import {Storage} from '@ionic/storage';
import {ToastController} from "ionic-angular";
import {ANALYTICS_ID} from "../constants/config";

@Injectable()
export class AnalyticsService {
  trackView(title){
    //console.log("Tracking", title);
    //this.ga.trackView(title);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/analytics.service.ts